<template>
    <el-form>
        <el-alert class="mb-4" v-if="alert.message" :title="alert.message" :type="alert.type" show-icon effect="dark"></el-alert>
        <el-form-item>
            <el-upload style="float:left;" accept="application/pdf" action="" :show-file-list="false" multiple :http-request="handleUploadRequest" :limit="30" :disabled="loading">
                <el-button :disabled="loading" :loading="loading" type="primary">{{ loading ? 'Uploading...' : 'Choose Files' }}</el-button>
            </el-upload>
            <el-button style="float:right;" type="danger" @click="handleClearForm">Clear</el-button> 
        </el-form-item>
        
        <el-form-item>
            <e-table :hideFooter="true" :data="items" :total="items.length" :headers="headers" :height="250">
                <template #actions="{scope}">
                    <el-button type="primary" @click.native="handlePDFPreview(scope.row)">Preview</el-button>
                    <el-button type="danger" @click.native="handleRemoveRow(scope.row)">Remove</el-button>
                </template>
            </e-table>
        </el-form-item>
        
        <el-form-item label="PDF Type:">
            <el-select size="large" placeholder="Select PDF Type"  style="width:100%;" v-model="pdfType" clearable @change="handleTypeChange">
                <el-option v-for="(item, index) in [{value:1, text: 'PDF Merger'},{value:2, text: 'PDF Splitter'}]" :key="index" :label="item.text" :value="item.value"></el-option>
            </el-select>
        </el-form-item>

        <el-form-item v-if="button.text === 'Split'" label="Split Type:">
            <el-select size="large" placeholder="Select Split Type"  style="width:100%;" v-model="splitType" clearable>
                <el-option v-for="(item, index) in splitTypeItems" :key="index" :label="item.text" :value="item.value"></el-option>
            </el-select>
            
        </el-form-item>

        <el-form-item v-if="button.text === 'Split'" label="Split Range:">
            <el-input size="large" placeholder="Enter Range separated by comma" v-model="splitRange"></el-input>
        </el-form-item>

        <el-form-item v-if="button.show" label="Rotate PDF? (Optional):">
            <el-select size="large" placeholder="Select PDF Rotation"  style="width:100%;" v-model="rotationValue" clearable>
                <el-option v-for="(item, index) in [0,90,180,360]" :key="index" :label="item" :value="item"></el-option>
            </el-select>
        </el-form-item>

        <el-form-item v-if="button.show" label="Filename:">
            <el-input size="large" placeholder="Enter Filename" v-model="filename"></el-input>
        </el-form-item>

        <el-form-item v-if="button.show">
            <el-button size="large"  type="primary" @click="handleImportPDF" :disabled="submitLoading" :loading="submitLoading">{{ button.text }}</el-button>
        </el-form-item>
        <PDFPreview ref="pdfPreviewDialog" />
    </el-form>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import * as type from '../../../store/types';

import PDFPreview from './PDFPreview';
export default {
    components: { PDFPreview },
    data: () => ({
        pdfType: '',
        splitType: '',
        splitRange: '',
        rotationValue: 0,
        filename: '',
        splitTypeItems: [
            {value:'onePage', text: 'One Page'},
            {value:'rangePages', text: 'Range Pages'},
            {value:'specificPages', text: 'Specific Pages'},
        ],
        alert: {
            type: '',
            message: ''
        },
        button: {
            show: false,
            text: ''
        }
    }),
    computed: {
        ...mapGetters({
            headers: 'pdfmanipulator/getUploadHeaders',
            items: 'pdfmanipulator/getUploadItems',
            loading: 'pdfmanipulator/getUploadLoading',
            submitLoading: 'pdfmanipulator/getLoading'
        })
    },
    methods: {
        ...mapActions({
            uploadPDF: `pdfmanipulator/${type.PDF_UPLOAD}`,
            removePDF: `pdfmanipulator/${type.PDF_UPLOAD_DELETE}`,
            clearPDF: `pdfmanipulator/${type.PDF_UPLOAD_CLEAR}`,
            importPDF: `pdfmanipulator/${type.PDF_ADD_LOGS}`
        }),
        handleUploadRequest(param){
            let file = param.file;
            if(file.type !== 'application/pdf'){
                this.$message({ type: "error", message: "Please upload pdf file!" });
                return;
            }
            console.log(file)
            let fd = new FormData();
            fd.append('files', file);

            this.uploadPDF(fd)
            .then(() => {
                this.uploadDialog = false
                this.handleTypeChange(this.pdfType)
            })
        },
        handlePDFPreview(row){
            this.$refs['pdfPreviewDialog'].handlePDF(row.filepath);
        },
        handleRemoveRow(row){
            this.removePDF(row)
            .then(() => this.handleTypeChange(this.pdfType))
        },
        handleClearForm(){
            this.clearPDF();
            this.handleTypeChange(0);
        },
        handleTypeChange(val){
            let totalTableRow = this.items.length;
            if(val === 2){
                if(totalTableRow > 1 || totalTableRow < 1){
                    this.setAlert('error','Oops! Please check the table below, make sure you uploaded one pdf only.');
                    this.setSubmitButton();
                }else{
                    if(this.items[0].pageCount > 1){
                        this.setAlert();
                        this.setSubmitButton(true,'Split');
                    }else{
                        this.setAlert('error','Unable to split pdf file with one page! Please re-upload pdf with more than 1 page.');
                        this.setSubmitButton();
                    }
                }
            }else if(val === 1){
                if(totalTableRow > 1){
                    this.setAlert();
                    this.setSubmitButton(true,'Merge');
                }else{
                    this.setAlert('error','Please upload atleast 2 pdf files before you can merge!');
                    this.setSubmitButton();
                }
            }else{
                this.pdfType = '';
                this.setAlert();
                this.setSubmitButton();
                this.splitType= ''
                this.splitRange= ''
                this.rotationValue= 0
                this.filename= ''            
            }
        },
        handleImportPDF(){
            if(this.pdfType === 1){
                if(!this.filename){
                    this.setAlert('error', 'Please input filename!')
                }else{
                    const mergePayload = {
                        pdfType: 1,
                        filename: `${this.filename}.pdf`,
                        userName: JSON.parse(localStorage.getItem('user')).user_name,
                        rotate: this.rotationValue,
                        files: this.items.map(e => e.filepath)
                    }
                    this.importPDF(mergePayload)
                    .then(msg => {
                        this.handleClearForm()
                        this.setAlert('success',msg);
                    })
                    .catch(error => this.setAlert('error',error.data))
                }
            }else{
                if(!this.filename){
                    this.setAlert('error', 'Please input filename!')
                }else{
                    const splitPayload = {
                        pdfType: 2,
                        splitType: this.splitType,
                        file: this.items[0].filepath,
                        filename: `${this.filename}.pdf`,
                        userName: JSON.parse(localStorage.getItem('user')).user_name,
                        rotate: this.rotationValue,
                        ranges: this.splitRange.split(',').map(e => parseInt(e))
                    }
                    this.importPDF(splitPayload)
                    .then(msg => {
                        this.handleClearForm()
                        this.setAlert('success',msg);
                    })
                    .catch(error => this.setAlert('error',error.data))
                }
            }
        },
        setSubmitButton(show=false, text=""){
            this.button = { show, text }
        },
        setAlert(type="", message=""){
           this.alert = { type, message }
        }
    }
}
</script>